"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvaluatorRouter = void 0;
const MathEvaluator_1 = require("./MathEvaluator");
const SpellingEvaluator_1 = require("./SpellingEvaluator");
const SentenceBuildEvaluator_1 = require("./SentenceBuildEvaluator");
const DictationEvaluator_1 = require("./DictationEvaluator");
const ComprehensionEvaluator_1 = require("./ComprehensionEvaluator");
const HandwritingCraftsmanshipEvaluator_1 = require("./HandwritingCraftsmanshipEvaluator");
const TracingEvaluator_1 = require("./TracingEvaluator");
const QuizEvaluator_1 = require("./QuizEvaluator");
const CompletionEvaluator_1 = require("./CompletionEvaluator");
const FlashcardReviewEvaluator_1 = require("./FlashcardReviewEvaluator");
const ConcreteMathEvaluator_1 = require("./ConcreteMathEvaluator");
const GroupingSortingEvaluator_1 = require("./GroupingSortingEvaluator");
const InteractiveMechanicEvaluator_1 = require("./InteractiveMechanicEvaluator");
class EvaluatorRouter {
    interactiveMechanicEvaluator = new InteractiveMechanicEvaluator_1.InteractiveMechanicEvaluator();
    evaluators = {
        maths: new MathEvaluator_1.MathEvaluator(),
        concrete_maths: new ConcreteMathEvaluator_1.ConcreteMathEvaluator(),
        grouping_sorting: new GroupingSortingEvaluator_1.GroupingSortingEvaluator(),
        directional_sequence: new CompletionEvaluator_1.CompletionEvaluator(),
        spelling: new SpellingEvaluator_1.SpellingEvaluator(),
        common_exception_words: new SpellingEvaluator_1.SpellingEvaluator(),
        sentence_building: new SentenceBuildEvaluator_1.SentenceBuildEvaluator(),
        dictation: new DictationEvaluator_1.DictationEvaluator(),
        reading_comprehension: new ComprehensionEvaluator_1.ComprehensionEvaluator(),
        letter_tracing: new TracingEvaluator_1.TracingEvaluator(),
        letter_formation: new HandwritingCraftsmanshipEvaluator_1.HandwritingCraftsmanshipEvaluator(),
        copy_writing: new HandwritingCraftsmanshipEvaluator_1.HandwritingCraftsmanshipEvaluator(),
        independent_writing: new HandwritingCraftsmanshipEvaluator_1.HandwritingCraftsmanshipEvaluator(),
        typed_composition: new ComprehensionEvaluator_1.ComprehensionEvaluator(),
        science_observation: new HandwritingCraftsmanshipEvaluator_1.HandwritingCraftsmanshipEvaluator(),
        history_source: new HandwritingCraftsmanshipEvaluator_1.HandwritingCraftsmanshipEvaluator(),
        geography_fieldnote: new HandwritingCraftsmanshipEvaluator_1.HandwritingCraftsmanshipEvaluator(),
        art_design_sketch: new HandwritingCraftsmanshipEvaluator_1.HandwritingCraftsmanshipEvaluator(),
        computing_design: new HandwritingCraftsmanshipEvaluator_1.HandwritingCraftsmanshipEvaluator(),
        re_reflection: new HandwritingCraftsmanshipEvaluator_1.HandwritingCraftsmanshipEvaluator(),
        interactive_story: new ComprehensionEvaluator_1.ComprehensionEvaluator(),
        story_reader: new CompletionEvaluator_1.CompletionEvaluator(),
        flashcard_review: new FlashcardReviewEvaluator_1.FlashcardReviewEvaluator(),
        quiz: new QuizEvaluator_1.QuizEvaluator(),
    };
    fallback = new HandwritingCraftsmanshipEvaluator_1.HandwritingCraftsmanshipEvaluator();
    async evaluate(submission, activity) {
        // If mechanic is an interactive KS2 / multi-modal mechanic, route to InteractiveMechanicEvaluator
        const interactiveMechanics = new Set([
            'block_sequence',
            'bar_model',
            'fraction_wall',
            'clause_builder',
            'text_detective',
            'branching_key',
            'timeline_sequence',
            'grid_reference',
            'grid_sequence',
        ]);
        if (activity.mechanic && interactiveMechanics.has(activity.mechanic)) {
            return this.interactiveMechanicEvaluator.evaluate(submission, activity);
        }
        const evaluator = this.evaluators[activity.type] ?? this.fallback;
        return evaluator.evaluate(submission, activity);
    }
}
exports.EvaluatorRouter = EvaluatorRouter;
